// extracted by mini-css-extract-plugin
module.exports = {"linkLiContainer":"FullWidthTextLink_linkLiContainer__l946D","linkBtn":"FullWidthTextLink_linkBtn__mg5mk","linkIcon":"FullWidthTextLink_linkIcon__HL6GQ"};